export default __webpack_public_path__ + "static/bnp-paribas-c4fa5f019a7f9696a70efb675cb28386.svg";